import { useState } from "react";

import logo from "../../assets/logo.png";
import Loader from "../Loader/Loader";

import styles from "./Header.module.css";

function Header({ toPDF, isBoletimLoading }) {
	const [isLoading, setIsLoading] = useState(false);

	async function handleDownload() {
		setIsLoading(true);

		var viewport = document.querySelector("meta[name=viewport]");

		viewport.setAttribute("content", "width=1366, initial-scale=1.0");

        setTimeout(() => {}, 2000); // Wait 2 seconds after changed viewport to generate PDF

		await toPDF();

		viewport.setAttribute("content", "width=device-width, initial-scale=1.0");

		setIsLoading(false);
	}

	return (
		<header className={styles.header}>
			<img
				src={logo}
				className={styles.logo}
				alt="Link"
			/>
			<button
				className={styles.button}
				onClick={handleDownload}
				disabled={isLoading || isBoletimLoading}
			>
				{isLoading ? <Loader /> : "Download"}
			</button>
		</header>
	);
}

export default Header;
